import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import StagingOrReturnModal from "./StagingOrReturnModal";
import useAuth from "src/hooks/useAuth";
import ScanOrEnterModal from "src/views/inventory/requests/orders/ScanOrEnterModal";
import ScanOutModal from "src/views/inventory/requests/orders/ScanOutModal";

export default function ReturnToStorage({ asset, internalWorkOrderItem, internalWorkOrder }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const [openModal, setOpenModal] = useState(false);
  const [openScanOrEnterModal, setOpenScanOrEnterModal] = useState(false);
  const [openScanModal, setOpenScanModal] = useState(false);

  const handleClick = () => {
    if (settings?.scan_out_modal) {
      setOpenScanOrEnterModal(true);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box mb={1}>
            <Typography fontWeight={500} fontSize={18}>
              Return to Storage
            </Typography>
          </Box>
          {internalWorkOrderItem.completedStatus ? (
            <Button fullWidth variant="outlined" color="primary" disabled>
              Returned to Storage
            </Button>
          ) : (
            <Button fullWidth variant="outlined" color="primary" onClick={handleClick}>
              Scan to Return Location
            </Button>
          )}
        </CardContent>
      </Card>

      {openModal && (
        <StagingOrReturnModal
          open={openModal}
          mode="return"
          asset={asset}
          item={internalWorkOrderItem}
          internalWorkOrder={internalWorkOrder}
          onClose={() => setOpenModal(false)}
        />
      )}

      {openScanOrEnterModal && (
        <ScanOrEnterModal
          asset={asset}
          onClose={() => setOpenScanOrEnterModal(false)}
          openScanModal={() => setOpenScanModal(true)}
          markAsPicked={async () => {
            setOpenScanOrEnterModal(false);
            setOpenModal(true);
          }}
          enableSuccessNotification={false}
        />
      )}

      {openScanModal && (
        <ScanOutModal
          asset={asset}
          onClose={() => setOpenScanModal(false)}
          onScanComplete={async () => {
            setOpenScanModal(false);
            setOpenModal(true);
          }}
        />
      )}
    </>
  );
}
